import React from 'react';
import { usePage, Link } from '@inertiajs/react';
import DashboardLayout from '@/components/DashboardLayout';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { ChevronRight, FileText, FolderOpen, Tag } from 'lucide-react';

interface AuthUser {
  id: number;
  name?: string;
  username?: string;
  email: string;
  role: 'user' | 'admin' | 'manager';
  role_level?: number;
}

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BlogLayoutProps {
  children: React.ReactNode;
  breadcrumbs?: BreadcrumbItem[];
}

const BlogLayout: React.FC<BlogLayoutProps> = ({ children, breadcrumbs = [] }) => {
  const { auth } = usePage().props as any;
  const user = auth?.user as AuthUser | undefined;

  // Default breadcrumbs for blog admin
  const defaultBreadcrumbs: BreadcrumbItem[] = [
    {
      label: 'Admin',
      href: '/admin',
    },
    {
      label: 'Blog',
      href: '/admin/blog/posts',
    },
  ];

  const allBreadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : defaultBreadcrumbs;

  return (
    <DashboardLayout>
      <div className="space-y-4">
        <Breadcrumb>
          <BreadcrumbList>
            {allBreadcrumbs.map((item, index) => (
              <React.Fragment key={item.label}>
                <BreadcrumbItem>
                  {item.href ? (
                    <BreadcrumbLink href={item.href}>{item.label}</BreadcrumbLink>
                  ) : (
                    <BreadcrumbPage>{item.label}</BreadcrumbPage>
                  )}
                </BreadcrumbItem>
                {index < allBreadcrumbs.length - 1 && (
                  <BreadcrumbSeparator>
                    <ChevronRight className="h-4 w-4" />
                  </BreadcrumbSeparator>
                )}
              </React.Fragment>
            ))}
          </BreadcrumbList>
        </Breadcrumb>
        
        {children}
      </div>
    </DashboardLayout>
  );
};

export default BlogLayout;
